import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import { compact, map } from 'lodash';
import { CallbackListForm } from './callbacklistform';
import cIf from 'classnames';
import { getMomentTZDateTime } from 'ts-util';

import { InSaleStatus } from '../../../types/models';
import { EventDateInfo } from '../../../mvcapi/models/common';

// TODO : EventNotInSaleCustomMessage devra Ãªtre ajouter pour RESERVATECH.NET
// TODO : CanShowAdditionalDateNotificationListEnabled

import TranslateManager from 'ts-translate-js';
const tr = TranslateManager.boundTR;

interface SaleMessagesInfoProps {
    eventDateInfo: EventDateInfo,
    onContentChange?: () => void,
    onMembershipPresaleClick?: (membershipTypeID: number, isInMembershipCardPreSaleAndHaveValidCard: boolean) => void
}

export const SaleMessagesInfo = createClass<SaleMessagesInfoProps>({
    displayName: "SaleMessagesInfo",

    propTypes: {
        eventDateInfo: PropTypes.object.isRequired,
        onContentChange: PropTypes.func,
        onMembershipPresaleClick: PropTypes.func
    },

    handleOnMembershipPresaleClick(membershipTypeID, isInMembershipCardPreSaleAndHaveValidCard) {
        if(this.props.onMembershipPresaleClick !== undefined) this.props.onMembershipPresaleClick(membershipTypeID, isInMembershipCardPreSaleAndHaveValidCard);
    },

    render() {

        let message = [];

        if(this.props.eventDateInfo.InSaleStatus === InSaleStatus.SALENOTSTARTEDYET) {

            let membershipMessages = [];

            if(this.props.onMembershipPresaleClick != null && this.props.eventDateInfo.MembershipPresaleInfos.length > 0) {
                membershipMessages = compact(map(this.props.eventDateInfo.MembershipPresaleInfos, (membershipPresaleInfo) => {
                    if(membershipPresaleInfo.IsActiveMembershipPresale) {
                        return (
                            <div key="membership" className="col-xs-12 upForSale">
                                <div className="col-xs-4 col-sm-4 text-right text-bold text-uppercase">{membershipPresaleInfo.MembershipName}</div>
                                <div className="col-xs-8 col-sm-4 text-left nowrap">{getMomentTZDateTime(membershipPresaleInfo.PresaleDate, this.props.eventDateInfo.TimeZone.TZDatabaseID).format(tsapp.tr("program.format.moment.datetime"))}</div>
                                <div className="col-xs-8 col-sm-4 pull-right">
                                    <button className="btn btn-xs btn-primary text-uppercase pull-left btn-xs-mobile"
                                            onClick={function() {
                                                this.handleOnMembershipPresaleClick(membershipPresaleInfo.MembershipTypeID, membershipPresaleInfo.IsInMembershipCardPreSaleAndHaveValidCard);
                                            }.bind(this) }>
                                        {tsapp.tr("program.salesinfo.buyinpresale")}</button>
                                </div>
                                <div className="col-xs-12 separator"></div>
                            </div>
                        );
                    }
                }));
            }

            message.push(
                <>
                    <div key="label" className="col-xs-12 text-justify">
                        <label>{tr("Mise en vente") + tr(":")}</label>
                    </div>
                    {membershipMessages}
                    <div key="public" className="col-xs-12 text-justify">
                        <div className="col-xs-4 col-sm-4 text-right text-bold text-uppercase nowrap">{tsapp.tr("program.salesinfo.public")}</div>
                        <div className="col-xs-8 col-sm-8 text-left nowrap">{getMomentTZDateTime(this.props.eventDateInfo.SalesStartDate, this.props.eventDateInfo.TimeZone.TZDatabaseID).format(tsapp.tr("program.format.moment.datetime"))}</div>

                    </div>
                </>
            );
        }
        else if(this.props.eventDateInfo.IsSoldOut)
        {
            message.push(<div key="soldout" className="col-xs-12">{tsapp.tr("program.salesinfo.soldoutevent")}</div>);
        }
        else if(this.props.eventDateInfo.InSaleStatus === InSaleStatus.PAST)
        {
            message.push(<div key="past" className="col-xs-12">{tsapp.tr("program.salesinfo.pastevent")}</div>);
        }
        else if(this.props.eventDateInfo.InSaleStatus === InSaleStatus.SALENOTEND || this.props.eventDateInfo.InSaleStatus === InSaleStatus.SALEFINISH)
        {
            if(this.props.eventDateInfo.EventNotInSaleCustomMessage != "")
                message.push(<div key="notinsale" className="col-xs-12" dangerouslySetInnerHTML={{__html: this.props.eventDateInfo.EventNotInSaleCustomMessage}}></div>); //gérer le html car le message a du html dedans pour le site reservatech.net
            else
                message.push(<div key="notinsale" className="col-xs-12">{tsapp.tr("program.salesinfo.notinsale")}</div>);
        }
        else
        {
            message.push(<div key="errorselling" className="col-xs-12">{this.props.eventDateInfo.ErrorSellingThisEventMessage}</div>);
        }

        return (
            <div>
                <div className={cIf("alert text-center", {"alert-warning": this.props.eventDateInfo.InSaleStatus === InSaleStatus.SALENOTSTARTEDYET,
                                                            "alert-danger": this.props.eventDateInfo.InSaleStatus !== InSaleStatus.SALENOTSTARTEDYET})}>
                    <div className="row">
                        {message}
                    </div>
                </div>
                <br />
                {this.props.eventDateInfo.IsSoldOut && this.props.eventDateInfo.EnableAdditionalDateNotificationList ? 
                    <CallbackListForm 
                        eventDateId={this.props.eventDateInfo.EventDateID}
                        onContentChange={this.props.onContentChange}
                    /> 
                : null}
            </div>
        );
    }
});
